import * as yup from 'yup'

export const busValidationSchema = (passengerCapacity: any) => {
  return yup.object().shape({
    postcode: yup.string().required('cannot be blank'),
    replacement_electric_bus: yup.string().required('cannot be blank'),
    bus_type: yup.string().required('cannot be blank'),
    distance: yup.string().required('cannot be blank'),
    number_of_passengers: yup
      .number()
      .when('replacement_electric_bus', (replacement_electric_bus) => {
        if (replacement_electric_bus && passengerCapacity) {
          return yup
            .number()
            .max(+passengerCapacity, `Maximum number of passengers is  ${passengerCapacity}`)
            .required('Please select bus type and replacement electric bus')
        } else return yup.number().required('Please select bus type and replacement electric bus')
      }),
    terrain_gradient: yup.string().required('cannot be blank'),
    selectedWeekDays: yup.array().required('test'),
  })
}

export const busSettingsSchema = yup.object().shape({
  price_of_diesel: yup
    .number()
    .min(0, 'enter price between 0 - 3')
    .max(3, 'enter price between 0 - 3'),
  peak_rate: yup.number().min(0, 'enter price between 0 - 1').max(1, 'enter price between 0 - 1'),
  shoulder_rate: yup
    .number()
    .min(0, 'enter price between 0 - 1')
    .max(1, 'enter price between 0 - 1'),
  off_peak_rate: yup
    .number()
    .min(0, 'enter price between 0 - 1')
    .max(1, 'enter price between 0 - 1'),
  operating_period: yup
    .number()
    .min(20, 'enter price between 20 - 30')
    .max(30, 'enter price between 20 - 30'),
})

export const vehicleValidationSchema = (payload: any) => {
  return yup.object().shape({
    heavy_vehicle_weight_class: yup.string().required('cannot be blank'),
    ice_chassis: yup.string().required('cannot be blank'),
    replacement_electric_vehicle_chassis: yup.string().required('cannot be blank'),
    auxiliary_load: yup.string().required('cannot be blank'),
    body_coast: yup.string().required('cannot be blank'),
    working_days: yup.array().required('Please select working days'),
    terrain: yup.string().required('cannot be blank'),
    vehicle_payload: yup
      .number()
      .when('replacement_electric_vehicle_chassis', (replacement_electric_vehicle_chassis) => {
        if (replacement_electric_vehicle_chassis && payload) {
          return yup
            .number()
            .max(+payload, `The maximum payload supported by the eV chassis is  ${payload} kg`)
            .required('Please select vehicle')
        } else return yup.number().required('Please select bus type and replacement electric bus')
      }),
  })
}
